import axios from 'axios';
import { useState, useEffect } from 'react';
import ModalPage from '../components/ModalPage';
import FullscreenLoader from '../components/FullscreenLoader';

type EntityItem = {
    id: number;
    key: string;
    title: string;
    alias: string;
    logo: string;
    url: string;
};

const STORAGE_KEY = 'lyfti_selected_entity';

const EntitySelector = () => {
    const [entities, setEntities] = useState<EntityItem[]>([]);
    const [search, setSearch] = useState('');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        axios.get(`${import.meta.env.VITE_API_BASE_URL}entity/`)
            .then(res => {
                setEntities(res.data);
                setLoading(false);
            })
            .catch(() => {
                setError('Kunne ikke laste inn områdelisten.');
                setLoading(false);
            });
    }, []);

    const handleSelect = (url: string) => {
        const hostname = url.replace(/^https?:\/\//, '').replace(/\/$/, '');
        localStorage.setItem(STORAGE_KEY, hostname);
        document.cookie = `${STORAGE_KEY}=${hostname}; path=/; SameSite=Strict`;
        window.location.reload();
    };

    const filtered = entities.filter(e =>
        e.title.toLowerCase().includes(search.toLowerCase())
    );

    if (loading) return <FullscreenLoader />;

    return (
        <ModalPage>
            <div className="d-flex flex-column flex-grow-1" style={{maxHeight: '70vh'}}>
                <div>
            <h2 className="mb-1">Velg område</h2>
            <p className="text-muted mb-3">Ingen konfigurasjon ble funnet for dette domenet.</p>
            {error && <div className="alert alert-danger">{error}</div>}
            <input
                className="form-control mb-3"
                placeholder="Søk..."
                value={search}
                onChange={e => setSearch(e.target.value)}
                autoFocus
            />
            </div>
            <div className='flex-grow-1' style={{ overflowY: 'auto' }}>
                {filtered.map(entity => (
                    <div
                        key={entity.id}
                        className="card flex-row cursor-pointer px-4 py-3 border rounded pointer w-100 text-start d-flex justify-content-between align-items-center gap-3 mb-2"
                        onClick={() => handleSelect(entity.url)}
                    >
                        
                        <span>{entity.title}</span>
                        <img
                            src={`${import.meta.env.VITE_API_BASE_URL}${entity?.logo?.replace(/^\//, '')}`}
                            alt={entity.title}
                            style={{ height: '28px', objectFit: 'contain', maxWidth: '150px', flexShrink: 0 }}
                        />
                    </div>
                ))}
                {filtered.length === 0 && (
                    <p className="text-muted text-center py-3">Ingen treff</p>
                )}
            </div>
            </div>
        </ModalPage>
    );
};

export default EntitySelector;
